/**
 * VERSIONE LIBRERIA 3
 */
var RenderBelongsto =  Render.extend({
    type : 'belongsto',
    classData : 'belongsto',
    classTemplate : 'belongsto',
    itemViewTemplate : null,
    separator : null,
    fields: {},
    nullLabel : '',

    _renderView : function(jQe) {
        var self = this;
        // TODO inserire anche i template per i belongsto
        /*
        var values = "";
        if (self.value) {
            for (var i in self.fields) {
                var f = self.fields[i];
                values += self.value[f] + " ";
            }
        }
        jQe.find('[data-render_element]').html(values);
        */
        if (!self.value) {
            jQe.find('[data-render_element]').html(self.nullLabel);
            return ;
        }

        if (self.itemViewTemplate) {
            var html = $.getTemplate(self.itemViewTemplate,self.value);
            jQe.find('[data-render_element]').html(html);
            return ;
        }
        var separator = self.separator?self.separator:" ";
        var label = "";
        //console.log('datai',self.value[i]);
        for (var fi in self.fields) {
            var field = self.fields[fi];
            label+= self.value[field];
            if (fi < self.fields.length-1)
                label+= separator;
        }

        jQe.find('[data-render_element]').html(label);

    },
    _finalizeView : function() {

    }
});